import { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { Navigate } from 'react-router-dom';
import { InteractionStatus } from '@azure/msal-browser';
import { loginRequest } from '@/auth';
import { paths } from '@/routes/paths';
import pathwayLogo from '@/assets/images/pathway-logo.png';

export function LoginPage() {
  const [logoError, setLogoError] = useState(false);
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  if (inProgress !== InteractionStatus.None) {
    return null;
  }

  if (isAuthenticated) {
    const redirectUrl = sessionStorage.getItem('redirectAfterLogin') || paths.dashboard;
    sessionStorage.removeItem('redirectAfterLogin');
    return <Navigate to={redirectUrl} replace />;
  }

  const handleLogin = () => {
    instance.loginRedirect(loginRequest);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '80vh',
        gap: 3,
      }}
    >
      {logoError ? (
        <Typography variant="h5" component="span" sx={{ minHeight: 40 }}>
          OC&C Pathway
        </Typography>
      ) : (
        <Box
          component="img"
          src={pathwayLogo}
          alt="OC&C Pathway"
          sx={{ maxHeight: 120 }}
          onError={() => setLogoError(true)}
        />
      )}
      <Typography variant="h4" component="h1">
        Welcome to OC&C Pathway
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Log in with your Azure account to continue.
      </Typography>
      <Button variant="contained" size="large" onClick={handleLogin}>
        GO TO LOGIN PAGE
      </Button>
    </Box>
  );
}

export default LoginPage;
